// The console's one CSV writer. Every export goes through it.
//
// A cell is always quoted (commas, quotes and newlines inside it are safe) and a cell a spreadsheet
// would run as a formula -- one starting with = + - @ or a tab / CR / LF -- gets a leading apostrophe
// so it opens as text. Exported rows carry text an outsider can influence (an organisation name, a
// resource id, a changes blob), so the guard is not optional and is not something each page may
// reinvent: AuditLogs had its own writer with the quoting and none of the guard.

export type CsvValue = string | number | null | undefined;

const FORMULA_LEAD = /^[=+\-@\t\r\n]/;

export function csvCell(value: CsvValue): string {
  const text = String(value ?? '');
  const safe = FORMULA_LEAD.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
}

/** A header row and the data rows, CRLF-separated (RFC 4180) unless `eol` says otherwise. */
export function toCsv(headers: readonly string[], rows: ReadonlyArray<readonly CsvValue[]>, eol = '\r\n'): string {
  return [headers.map(csvCell).join(','), ...rows.map((row) => row.map(csvCell).join(','))].join(eol);
}
